import { render, staticRenderFns } from "./NotificationBannersList.vue?vue&type=template&id=1b42eecc&"
import script from "./NotificationBannersList.vue?vue&type=script&lang=js&"
export * from "./NotificationBannersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports